import { render, staticRenderFns } from "./messageList.vue?vue&type=template&id=111e3d72"
import script from "./messageList.vue?vue&type=script&lang=js"
export * from "./messageList.vue?vue&type=script&lang=js"
import style0 from "./messageList.vue?vue&type=style&index=0&id=111e3d72&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports